import ko from 'knockout';

ko.bindingHandlers.embed = {
  init() {
    return {
      controlsDescendantBindings: true
    };
  },
  update(element, valueAccessor) {
    let value = ko.unwrap(valueAccessor());
    if (!value) {
      return;
    }

    const fireOnce = !!value.fireOnce;
    const div = document.createElement('div');

    value = value.value || value;
    if (value instanceof HTMLElement) {
      div.appendChild(value);
    } else {
      div.innerHTML = value;
    }

    ko.virtualElements.emptyNode(element);
    if (fireOnce) {
      ko.cleanNode(element);
    }

    let i = div.children.length;
    while (i--) {
      ko.virtualElements.prepend(element, div.children[i]);
    }
  }
};

ko.virtualElements.allowedBindings.embed = true;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./assets/scripts/handlers/embed.babel.js
 **/